import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WebSocketMessage, WebSocketRegistryState } from "@/services/websocket/types";

const initialState: WebSocketRegistryState = {
  connections: {},
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    initConnection: (state, action: PayloadAction<string>) => {
      const connectionId = action.payload;
      state.connections[connectionId] = {
        isConnected: false,
        isConnecting: false,
        latestMessage: null,
        error: null,
      };
    },
    connectionConnecting: (state, action: PayloadAction<string>) => {
      const connection = state.connections[action.payload];
      if (connection) {
        connection.isConnected = false;
        connection.isConnecting = true;
      }
    },
    connectionOpened: (state, action: PayloadAction<string>) => {
      const connectionId = action.payload;
      const connection = state.connections[connectionId];
      if (connection) {
        connection.isConnected = true;
        connection.isConnecting = false;
        connection.error = null;
      }
    },
    connectionClosed: (state, action: PayloadAction<string>) => {
      const connectionId = action.payload;
      const connection = state.connections[connectionId];
      if (connection) {
        connection.isConnected = false;
        connection.isConnecting = false;
      }
    },
    connectionErrored: (state, action: PayloadAction<{ connectionId: string; error: string }>) => {
      const { connectionId, error } = action.payload;
      const connection = state.connections[connectionId];
      if (connection) {
        connection.error = error;
      }
    },
    messageReceived: (
      state,
      action: PayloadAction<{ connectionId: string; message: WebSocketMessage }>
    ) => {
      const { connectionId, message } = action.payload;
      const connection = state.connections[connectionId];
      if (connection) {
        connection.latestMessage = message;
      }
    },
    removeConnection: (state, action: PayloadAction<string>) => {
      const connectionId = action.payload;
      delete state.connections[connectionId];
    },
  },
});

export const {
  initConnection,
  connectionConnecting,
  connectionOpened,
  connectionClosed,
  connectionErrored,
  messageReceived,
  removeConnection,
} = websocketSlice.actions;

export default websocketSlice.reducer;
